module.exports = __webpack_public_path__ + "static/img/labmacambira.f925853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/full/projects/labmacambira.png
// module id = C1qZ
// module chunks = 0